import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { DateTime } from "luxon";

import { SECTION_LABEL_SX } from "/imports/ui/components/booking";
import ClassCard from "./ClassCard";

// The "scroll through the week" day view: one labelled section per non-empty
// day, each anchored so the day strip's scroll-spy stays in sync. Shared by the
// mobile layout and desktop Day mode.
function ClassDaySections({ cls, scrollSpy }) {
  const {
    nonEmptyDays,
    classesByDate,
    currency,
    handleJoin,
    handleJoinWaitlist,
    handleLeaveWaitlist,
    handleOpenDetail,
    packageOfferFor,
    handleViewPackage
  } = cls;
  const { sectionRefs, sectionOffset } = scrollSpy;

  return (
    <Box>
      {nonEmptyDays.map((d) => {
        const dt = DateTime.fromISO(d);
        const dayClasses = classesByDate.get(d) || [];
        return (
          <Box
            key={d}
            data-day={d}
            ref={(el) => {
              sectionRefs.current[d] = el;
            }}
            sx={{ scrollMarginTop: `${sectionOffset}px`, mb: 3.5 }}
          >
            <Typography sx={{ ...SECTION_LABEL_SX, mb: 1.5 }}>
              {dt.toFormat("cccc d LLL")} · {dayClasses.length}
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              {dayClasses.map((c) => (
                <ClassCard
                  key={c._id}
                  cls={c}
                  currency={currency}
                  onJoin={() => handleJoin(c)}
                  onJoinWaitlist={handleJoinWaitlist}
                  onLeaveWaitlist={handleLeaveWaitlist}
                  onOpen={() => handleOpenDetail(c)}
                  packageOffer={packageOfferFor(c)}
                  onViewPackage={handleViewPackage}
                />
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default ClassDaySections;
